import { INVALIDATE_CLIENT, INVALIDATE_PLAN_COMPTABLE } from 'actions/invalidationTags';
import { ApiMananger } from "actions/rtkquery";
import {
  ADD_ECRITURE_MANUELLE,
  CLEANUP_ORPHAN_ECRITURES,
  CORRIGER_BILAN_COMPTABLE,
  ECRITURES_MULTILIGNES,
  IMPORT_ECRITURES,
  RECONSTRUCTION_COMPTABLE,
  WORKFLOW_ECRITURE_MANUELLE,
} from "routes/api/endpoints";

const INITIALISER_PLAN_COMPTABLE = process.env.REACT_APP_API_URL + '/comptable/initialiser/';

const comptabiliteMutationsApi = ApiMananger.injectEndpoints({
  endpoints: (build) => ({
    // Initialiser le plan comptable (SYSCOHADA + Personnalisés)
    initialiserPlanComptable: build.mutation({
      query: (body) => ({
        url: INITIALISER_PLAN_COMPTABLE,
        method: "POST",
        body,
      }),
      invalidatesTags: [INVALIDATE_CLIENT, INVALIDATE_PLAN_COMPTABLE],
    }),
    createEcritureManuelle: build.mutation({
      query: (body) => ({
        url: ADD_ECRITURE_MANUELLE,
        method: "POST",
        body,
      }),
      invalidatesTags: [INVALIDATE_CLIENT],
    }),
    createEcritureMultilignes: build.mutation({
      query: (body) => ({
        url: ECRITURES_MULTILIGNES,
        method: "POST",
        body,
      }),
      invalidatesTags: [INVALIDATE_CLIENT, INVALIDATE_PLAN_COMPTABLE],
    }),
    deletePieceMultilignes: build.mutation({
      query: (body) => ({
        url: ECRITURES_MULTILIGNES,
        method: "DELETE",
        body,
      }),
      invalidatesTags: [INVALIDATE_CLIENT],
    }),
    importEcritures: build.mutation({
      query: (formData) => ({
        url: IMPORT_ECRITURES,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: [INVALIDATE_CLIENT, INVALIDATE_PLAN_COMPTABLE],
    }),
    corrigerBilanComptable: build.mutation({
      query: (body) => ({
        url: CORRIGER_BILAN_COMPTABLE,
        method: "POST",
        body,
      }),
      invalidatesTags: [INVALIDATE_CLIENT],
    }),
    reconstructionComptable: build.mutation({
      query: (body) => ({
        url: RECONSTRUCTION_COMPTABLE,
        method: "POST",
        body,
      }),
      invalidatesTags: [INVALIDATE_CLIENT],
    }),
    workflowEcritureManuelle: build.mutation({
      query: ({ ecriture_id, action }) => ({
        url: `${WORKFLOW_ECRITURE_MANUELLE}${ecriture_id}/workflow/`,
        method: "POST",
        body: { action },
      }),
      invalidatesTags: [INVALIDATE_CLIENT],
    }),
    updateEcritureManuelle: build.mutation({
      query: ({ ecriture_id, ...body }) => ({
        url: `${ADD_ECRITURE_MANUELLE}${ecriture_id}/`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: [INVALIDATE_CLIENT],
    }),
    deleteEcritureManuelle: build.mutation({
      query: ({ ecriture_id }) => ({
        url: `${ADD_ECRITURE_MANUELLE}${ecriture_id}/`,
        method: "DELETE",
      }),
      invalidatesTags: [INVALIDATE_CLIENT],
    }),
    cleanupOrphanEcritures: build.mutation({
      query: (body) => ({
        url: CLEANUP_ORPHAN_ECRITURES,
        method: "POST",
        body,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useInitialiserPlanComptableMutation,
  useCreateEcritureManuelleMutation,
  useCreateEcritureMultilignesMutation,
  useDeletePieceMultilignesMutation,
  useImportEcrituresMutation,
  useCorrigerBilanComptableMutation,
  useReconstructionComptableMutation,
  useWorkflowEcritureManuelleMutation,
  useUpdateEcritureManuelleMutation,
  useDeleteEcritureManuelleMutation,
  useCleanupOrphanEcrituresMutation,
} = comptabiliteMutationsApi;
